import React from 'react';
import T from 'prop-types';
// styles
import styles from './Icon.mod.css';
import classnames from 'classnames/bind';

let cx = classnames.bind(styles);

const Icon = ({ type, className, onClick, color, ...otherProps }) => {
  const colorStyle = color ? { backgroundColor: color } : undefined;

  return (
    <i
      onClick={onClick}
      className={cx('icon', `icon-${type}`, className, {
        clickable: onClick,
      })}
      style={colorStyle}
      {...otherProps}
    />
  );
};

Icon.propTypes = {
  className: T.string,
  onClick: T.func,
  color: T.string,
  type: T.oneOf([
    'sidebar',
    'back',
    'arrow-right',
    'arrow-chart',
    'close',
    'eye',
    'eye-closed',
    'calendar',
    'file',
    'quiz',
    'video',
    'link',
    'ellipse',
    'ellipse-full',
    'lock',
    'input',
    'slideshow',
    'chevron-up',
    'arrow-right-long',
    'arrow-left-long',
    'recovery',
    'add',
    'edit',
    'pen',
    'delete',
    'edit',
    'clock',
    'check',
    'star',
    'pen-in-circle',
    'check-circle',
    'calendar-alt',
    'check-circle',
    'check-square',
    'comment-edit',
    'comment',
    'chevron-double-up',
    'help',
    'male',
    'female',
    'genderless',
    'calendar-check',
    'award',
  ]),
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/Icon/Icon.jsx